import React from "react"
import PropTypes from "prop-types"

const dataHash = {
  CONTRACT_METHOD_INTERVIEW: '面访',
  CONTRACT_METHOD_TELE_SALE: '电销',
  CONTRACT_METHOD_MEETING_SALE: '会销',
  CONTRACT_METHOD_NETWORK_SALE: '网销',
  CONTRACT_METHOD_AUTO_SELF: '自助', // 5
};

class ContractMethod extends React.Component {
  static propTypes = {
    contractMethod: PropTypes.string,
  }

  render() {
    const { contractMethod } = this.props
    if (!contractMethod) {
      return null
    }
    const value = dataHash[contractMethod];
    if (!value) {
      return null;
    }

    return <span>{value}</span>;
  }
}

export default ContractMethod;
